import { StorageKeys } from "../constants/storage"
import { isLocalDev } from "../utils/general"

const storage = localStorage

export const useStorage = () => {
  const setItem = (key: StorageKeys, value: string) => {
    storage.setItem(key, value)
  }

  const getItem = <T>(key: StorageKeys): T | null => {
    const value = storage.getItem(key) as T | null
    return value
  }

  const removeItem = (key: StorageKeys) => {
    storage.removeItem(key)
  }

  return { setItem, getItem, removeItem }
}
